import React from 'react';
export var Subtitle = function (_a) {
    var children = _a.children;
    return (React.createElement("h4", { className: "font-body text-body text-sm font-light font-italic mb-0" }, children));
};
Subtitle.displayName = 'Card.Subtitle';
